import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CopiedSourcingEventDto, useCopySourcingEventMutation } from "../../autogen/bff-api";
import { useApiError } from "../../common/errors/useApiError";
import { urls } from "../../urls";
import { InvitationsLeftOutModal } from "./InvitationsLeftOutModal";

export const useCopyProcurement = ({ onError }: { onError?: (e: unknown) => void } = {}) => {
  const navigate = useNavigate();
  const { trigger } = useApiError();
  const [copyEvent, { isLoading }] = useCopySourcingEventMutation();
  const [copyWithInvitationsLeftOut, setCopyWithInvitationsLeftOut] = useState<CopiedSourcingEventDto | null>(null);
  const reportError = onError ?? trigger;

  const openCopy = (copied: CopiedSourcingEventDto) => navigate(urls.app.sourcingEvents.edit.go(copied.event.id).info);

  const copy = async (eventId: string) => {
    try {
      const copied = await copyEvent({ eventId }).unwrap();
      if (copied.skippedInvitations > 0) {
        setCopyWithInvitationsLeftOut(copied);
        return;
      }
      openCopy(copied);
    } catch (e) {
      reportError(e);
    }
  };

  const modal = copyWithInvitationsLeftOut ? (
    <InvitationsLeftOutModal
      copied={copyWithInvitationsLeftOut}
      onOpenCopy={() => {
        setCopyWithInvitationsLeftOut(null);
        openCopy(copyWithInvitationsLeftOut);
      }}
    />
  ) : null;

  return { copy, isCopying: isLoading, modal };
};
